export class InjectedRule {
  isEditDisabled: boolean;
  // TODO: 単体警告として解釈するべきか名称警告として解釈するべきか
  // 円選択・チェックは単体警告にしても意味が無い
  isNameGroupEmptyCheckEnabled: boolean;
}
